module.exports = __webpack_public_path__ + "static/media/valor2_3_2.44457afa.png";